export default {
  id: 56,
  title: 'Target #56 - Skull',
  url: 'https://cssbattle.dev/play/56',
  colors: ['#191919', '#4F77FF'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#191919}a{position:fixed;background:#4F77FF}a[a]{top:85;left:140;width:120;height:100;border-radius:60px 60px 10px 10px}a[b]{top:175;left:160;width:80;height:40;border-radius:0 0 20px 20px}a[c],a[d]{background:#191919}a[c]{top:176;left:190;width:20;height:20;border-radius:50%;box-shadow:-25px -28px 0 10px #191919,25px -28px 0 10px #191919}a[d]{top:205;left:180;width:10;height:15;border-radius:10px;box-shadow:15px 0 #191919,30px 0 #191919}</style>',
}
